{
    "coordinates": [
        -19.02884061749854,
        138.73982886329912
    ],
    "tooltip": "Riversleigh",
    "title": "Riversleigh (Faunal Zone C)",
    "country": "Australia",
    "period": "Paleogene-Neogene",
    "alt": "TODO"
}
